import { useAppSelector } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { clearFilter, listStore, useAccountRepository, useLicenseRepository } from '@frontend/repository';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

const LIST_ID = 'awaiting-drop-off-list';
export const useAwaitingDropOff = () => {
    const { openModal } = useModals();
    const { currentAccount } = useAccountRepository();
    const { functionalities } = useLicenseRepository();
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as { functionalityId?: string } | null;
    const formId = 'awaiting-drop-off-form';
    const [trackingNumberValid, setTrackingNumberValid] = useState<boolean>(true);
    const functionalityId = locationState?.functionalityId ?? new URLSearchParams(location.search).get('functionalityId');
    const dispatch = useAppDispatch();
    const listState = useAppSelector(useSelector, listStore);
    const functionality = useMemo(() => {
        if (!functionalityId) return null;
        return functionalities.find((f) => f.id === functionalityId) ?? null;
    }, [functionalities, functionalityId]);
    useEffect(() => {
        return () => {
            dispatch(clearFilter({ listId: LIST_ID }));
        };
    }, []);

    const functionalityWizardId = functionality?.wizard_id ?? null;

    return {
        openModal,
        currentAccount,
        navigate,
        location,
        formId,
        trackingNumberValid,
        setTrackingNumberValid,
        dispatch,
        functionality,
        functionalityWizardId
    };
};
